import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    '& > button': {
      padding: '8px 10px'
    }
  },
  sliderContainer: {
    marginLeft: '15px',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    '& p': {
      margin: 0,
      textAlign: 'center'
    },
    [theme.breakpoints.between(0, 'mobile')]: {
      width: 'auto'
    },
    position: 'relative',
    height: '52px',
    justifyContent: 'center',
    paddingRight: '10px'
  },
  sliderDate: {
    position: 'absolute',
    bottom: '-7px',
    left: '50%',
    transform: 'translate:(-50%, 0)'
  }
}))
